export default function getErrorStatusCode(err) {
  var code
  if (err.response) {
    code = err.response.status
  } else if (err.request) {
    code = err.request.status
  }
  return code
}



// WEBPACK FOOTER //
// ./src/utils/error_status_code.js